import { useContext } from "react";
import { ShopContext } from "../Context/ShopContext";
import { useParams } from "react-router-dom";
import ProductDisplay from "../Components/ProductDisplay/ProductDisplay";
import DescriptionBox from "../Components/DescriptionBox/DescriptionBox";

const Product = () => {
  const { allProducts } = useContext(ShopContext);
  const { productId } = useParams();

  // ⛔ Products abhi load nahi hue
  if (!allProducts || allProducts.length === 0) {
    return (
      <div style={{ padding: "100px", textAlign: "center" }}>
        Loading products...
      </div>
    );
  }

  // ✅ Products aa chuke hain
  const product = allProducts.find(
    (item) => item.id === Number(productId)
  );

  // ⛔ Invalid product ID
  if (!product) {
    return (
      <div style={{ padding: "100px", textAlign: "center" }}>
        Product not found
      </div>
    );
  }

  return (
    <div>
      <ProductDisplay product={product} />
      <DescriptionBox />
    </div>
  );
};

export default Product;
